import { navigateToOptions } from "@app/connectors/history-connectors"
import PathNames from "@app/const/PathNames"
import { RootState } from "@app/types/root-state"
import { NativeEventBridge } from "@ng-mw/shared-react-components"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useLocation } from "react-router"
import { useShouldUseNativeTabBar } from "@app/helpers/nativeTabBar/useShouldUseNativeTabBar"
import MenyNativeEvent from "@app/events/MenyNativeEvent"

const getTabForPath = (pathname: string) => {
    if (pathname === PathNames.Home) return navigateToOptions.HJEM
    if (pathname.startsWith(PathNames.Search) || pathname.startsWith(PathNames.Products))
        return navigateToOptions.BUTIKK
    if (pathname.startsWith(PathNames.Cart)) return navigateToOptions.KURV
    if (pathname.startsWith(PathNames.BestBuy)) return navigateToOptions.GODEKJØP
    if (pathname.startsWith(PathNames.RecipesHome)) return navigateToOptions.OPPSKRIFTER

    return undefined
}

export const useNativeTabBarTab = () => {
    const { pathname } = useLocation()
    const appEnv = useSelector((state: RootState) => state.appEnvConfig)

    const shouldUseTabBar = useShouldUseNativeTabBar(appEnv.supportsNativeTabs)

    useEffect(() => {
        if (!shouldUseTabBar) {
            return
        }

        NativeEventBridge.broadcastNative(MenyNativeEvent.TabBarSelectTab, {
            navigateTo: getTabForPath(pathname) ?? null,
        })
    }, [shouldUseTabBar, pathname])
}
